module.exports = __webpack_public_path__ + "img/ca.a1902447.svg";